import { useAdsbLayer } from './use_adsb_layer'
import { useAdsbDataSourceTable } from './use_adsb_data_source_table'
import { useEfbLayer } from './use_efb_layer'
import { useEfbDataSourceTable } from './use_efb_data_source_table'

import { SeparationCylinder } from './separation_cylinder'

function createToolbar (cesiumViewer) {
  const viewerDom = $(cesiumViewer.container).find('.cesium-viewer')

  const toolbar = $('<div/>', { class: 'cesium-viewer-toolbar-container' })
  viewerDom.append(toolbar)

  return toolbar
}

export const withAircraftLayer = (controller, { cesiumViewer }) => {
  const $toolbar = createToolbar(cesiumViewer)

  const $tablesContainer = $('<div/>', { class: 'aircraft-tables-container' })

  const $adsbGroup = $('<div/>', { class: 'aircraft-button-group' })
  $toolbar.append($adsbGroup)
  useAdsbDataSourceTable(controller, { cesiumViewer, dataSourceId: 'adsb-data-source', container: $tablesContainer, buttonGroup: $adsbGroup })
  useAdsbLayer(controller, { cesiumViewer, buttonGroup: $adsbGroup })

  const $efbGroup = $('<div/>', { class: 'aircraft-button-group' })
  $toolbar.append($efbGroup)
  useEfbDataSourceTable(controller, { cesiumViewer, dataSourceId: 'efb-data-source', container: $tablesContainer, buttonGroup: $efbGroup })
  useEfbLayer(controller, { cesiumViewer, buttonGroup: $efbGroup })

  const separationCylinder = new SeparationCylinder(
    controller, {
      cesiumViewer,
      toolbar: $toolbar
    }
  )

  $toolbar.append($tablesContainer)

  return {
    setSeparationTarget: (separationEntity) => {
      controller.setAdsbTableSeparationTarget(separationEntity)
      controller.setEfbTableSeparationTarget(separationEntity)
      separationCylinder.setSepEntity(separationEntity)
    }
  }
}
